import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=c680882a&scoped=true&"
import script from "./leftBottom.vue?vue&type=script&lang=js&"
export * from "./leftBottom.vue?vue&type=script&lang=js&"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=c680882a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c680882a",
  null
  
)

export default component.exports